import { Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-trust-chart-of-account',
  templateUrl: './trust-chart-of-account.component.html',
  styleUrls: ['./trust-chart-of-account.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class TrustChartOfAccountComponent implements OnInit {
  theme_type = localStorage.getItem('theme_type');
  selectedColore: string = 'var(--highlighted-bg-row)';
  isLoadingResults: boolean = false;

  constructor() {}

  /**
   * It runs once after the component's view has been fully initialized.
   */
  ngOnInit() {}
  //FilterSearch
  FilterSearch() {}
  //AccountType
  AccountType(value) {}
  //Refersh
  refreshturstcAC() {}
}
